import { Reducer } from 'redux'
import { initialProfileState } from './initialState'
import { LOGIN, LOGINTOKEN, LOGOUT, ProfileActionTypes, ProfileState } from './types'

const reducer: Reducer<ProfileState, ProfileActionTypes> = (state: ProfileState = initialProfileState, action: ProfileActionTypes) => {
	switch (action.type) {
		case LOGINTOKEN:
		case LOGIN: {
			return {
				...state, ...{ authenticated: action.payload.authenticated }
			}
		}
		case LOGOUT: {
			return {
				...state, ...{ authenticated: false }
			}
		}
		default: {
			return state
		}
	}
}

export { reducer as profileReducer }
